module.exports = __webpack_public_path__ + "img/9788994475677.bb55e43d.jpg";